<template>
  <svg class="customIcon" fill="white" height="28" viewBox="0 0 29 28" width="29" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.3889 0H3.61111C1.9 0 0.5 1.4 0.5 3.11111V24.8889C0.5 26.6 1.9 28 3.61111 28H25.3889C27.1 28 28.5 26.6 28.5 24.8889V3.11111C28.5 1.4 27.1 0 25.3889 0ZM9.83333 21.7778H6.72222V10.8889H9.83333V21.7778ZM16.0556 21.7778H12.9444V6.22222H16.0556V21.7778ZM22.2778 21.7778H19.1667V15.5556H22.2778V21.7778Z" fill="white"/>
  </svg>
</template>

<script>
export default { name: "ChartIcon" };
</script>
